module.exports = __webpack_public_path__ + "static/media/WhatMatters.4fea53a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/How it works/WhatMatters.jpg
// module id = 303
// module chunks = 0